import React from 'react';
import cn from 'classnames';
import sortBy from 'lodash/sortBy';
import isIE from 'ps-components/Utils/checkForIE';
import { string, array, func, number, bool, object } from 'prop-types';

import './DropdownViews.scss';

const scopeMappingViews = {
  personal: 'My Views',
  group: 'Group Views',
  site: 'Site Views',
  global: 'Global Views'
};

const scopeMappingDashboard = {
  personal: 'My Dashboards',
  group: 'Group Dashboards',
  site: 'Site Dashboards',
  global: 'Global Dashboards'
};

const scopeOrder = ['personal', 'group', 'site', 'global'];

DropdownViews.propTypes = {
  canUserCreate: bool,
  className: string,
  groupAdminCanConfigureViews: bool,
  id: string,
  isDashboard: bool,
  onEdit: func,
  onSelectView: func,
  regularUserCanConfigureViews: bool,
  selectedViewPk: number,
  userRights: object,
  views: array
};

function DropdownViews(props) {
  const scopeMapping = props.isDashboard ? scopeMappingDashboard : scopeMappingViews;
  const viewText = props.isDashboard ? 'Dashboard' : 'View';

  function canUserCreate() {
    const { reportViewUser, restrictedUser, groupAdmin, siteAdmin, globalAdmin, superAdmin } = props.userRights;
    const { groupAdminCanConfigureViews, regularUserCanConfigureViews } = props;

    const groupOrAbove = groupAdmin || siteAdmin || globalAdmin || superAdmin;
    const siteOrAbove = siteAdmin || globalAdmin || superAdmin;

    if (restrictedUser || reportViewUser) return false;

    // regular users
    if (!groupOrAbove) {
      if (regularUserCanConfigureViews) return true;
      else return false;
    }

    // group admins
    if (!siteOrAbove) {
      if (groupAdminCanConfigureViews) return true;
      else return false;
    }

    // site and above admins
    return true;
  }

  function getViewsList() {
    const scopeList = {};
    const viewList = [];

    // group views by scope
    props.views.forEach(view => {
      const scope = view.scope;
      if (!scopeList[scope]) scopeList[scope] = [];

      scopeList[scope].push({ ...view, view_name_lower: view.view_name?.toLowerCase() });
      scopeList[scope] = sortBy(scopeList[scope], ['view_name_lower'], ['asc']);
    });

    // build dropdown list items
    scopeOrder.forEach(key => {
      const scopeItems = scopeList[key];

      if (scopeItems?.length > 0) {
        const scopeTitle = scopeMapping[key];

        viewList.push(
          <div key={`${key}-title`} className="scope-title">
            {scopeTitle}
          </div>
        );

        scopeItems?.forEach((item, index) => {
          viewList.push(
            <div
              key={`${key}-${index}`}
              className={cn('view-item', { selected: props.selectedViewPk === item.view_pk })}
              onClick={() => props.onSelectView(item.view_name, item)}
            >
              {item.view_name}
            </div>
          );
        });
      }
    });

    return viewList;
  }

  return (
    <div className={cn('dropdown-views', props.className, { 'dropdown-ie': isIE() })} id={props.id}>
      <div className="dropdown-views__header">
        <div className="dropdown-views__title">{viewText}s</div>
        {!props.userRights.restrictedUser && (
          <div className="dropdown-views__edit-link" onClick={props.onEdit}>
            {canUserCreate() ? `Edit ${viewText}s` : 'View Details'}
          </div>
        )}
      </div>

      <div className="dropdown-views__list">{getViewsList()}</div>
    </div>
  );
}

export default DropdownViews;
